import axios from 'axios';
import { getEventListQuery, getEventDetailsQuery } from './GQLQueries';

/**
 * Loads the list of event for an observation in the given timeframe.
 *
 * @param {String} graphQlHubServiceUrl
 * @param {String} username
 * @param {String} observationName
 * @param {Date} endDate
 * @param {Number} periodCount
 */
const getEventListForObservation = async (
  graphQlHubServiceUrl,
  username,
  observationName,
  endDate,
  periodCount,
  cancelToken = undefined
) => {
  const response = await axios.post(
    graphQlHubServiceUrl,
    {
      query: getEventListQuery,
      variables: {
        username: username,
        observationName: observationName,
        endDate: endDate,
        periodCount: periodCount
      }
    },
    Object.assign(
      {},
      {
        cancelToken: cancelToken
      }
    )
  );

  return response.data.data.safetyEventList;
};

/**
 * Load event details for many event numbers.
 *
 * @param {String} graphQlHubServiceUrl
 * @param {String} eventNumbers
 */
const getEventDetails = async (
  graphQlHubServiceUrl,
  eventNumbers = [],
  cancelToken = undefined
) => {
  const response = await axios.post(
    graphQlHubServiceUrl,
    {
      query: getEventDetailsQuery,
      variables: {
        eventNumbers: eventNumbers
      }
    },
    Object.assign(
      {},
      {
        cancelToken: cancelToken
      }
    )
  );

  return response.data.data.safetyEventDetails;
};

export { getEventListForObservation, getEventDetails };



// WEBPACK FOOTER //
// ./src/apis/EventsApi.js